package br.com.vvrefeicoes.portal.core.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.graphics.Color

@Immutable
data class AppExtraColors(
    val success: Color,
    val onSuccess: Color,
    val successContainer: Color,
    val onSuccessContainer: Color,
    val warning: Color,
    val onWarning: Color,
    val warningContainer: Color,
    val onWarningContainer: Color,
    val info: Color,
    val onInfo: Color,
    val infoContainer: Color,
    val onInfoContainer: Color,
)

val AppLightExtraColors =
    AppExtraColors(
        success = AppPalette.Success500,
        onSuccess = AppPalette.Neutral0,
        successContainer = AppPalette.Success100,
        onSuccessContainer = AppPalette.Success900,
        warning = AppPalette.Warning500,
        onWarning = AppPalette.Neutral0,
        warningContainer = AppPalette.Warning100,
        onWarningContainer = AppPalette.Warning900,
        info = AppPalette.Info500,
        onInfo = AppPalette.Neutral0,
        infoContainer = AppPalette.Info100,
        onInfoContainer = AppPalette.Info900,
    )

val LocalAppExtraColors =
    staticCompositionLocalOf<AppExtraColors> {
        error("AppExtraColors não foi fornecido. Use AppTheme { ... }.")
    }
